const networkLeakage = {
  titleAndSubtitle: {
    title: 'Network Usage',
    subtitle:
      'A comparison of claims and cost distribution by in-network and out-of-network providers.',
  },
  CalendarCard: {
    from: 'January 2021',
    to: 'December 2022',
  },
  cardText: {
    members: 'Members',
    totalCost: 'Total Cost',
    memberPaid: 'Member Paid',
    planPaid: 'Plan Paid',
    pmpm: 'PMPM',
    pepm: 'PEPM',
  },
  TableText: {
    title: (network_indicator: string) =>
      `Top ${network_indicator} Network Providers`,
    subtitle: ' ',
    inNetwork: 'In-Network',
    outNetwork: 'Out-of-Network',
  },
};
export default networkLeakage;
